import axios from 'axios'

export default {
  state: {
    documents: []
  },
  mutations: {
    SET_DOCUMENTS(state, documents) {
      state.documents = documents
    }
  },
  actions: {
    loadDocuments({ commit }, lfdnr) {
      axios.get(`/v1/crm/addresses/${lfdnr}/documents`).then(response => {
        response.data.forEach(element => {
          element.printLoading = false
          element.name = `${element.shortType} ${element.nr}`
        })
        commit('SET_DOCUMENTS', response.data)
      })
    }
  },
  getters: {}
}
